import Vue from 'vue'
import Router from 'vue-router'
import menuModule from '../store/modules/menu'

Vue.use(Router)

let isHistoryApi = !!(window.history && history.pushState)

export default new Router({
    mode: isHistoryApi ? 'history' : 'hash',
    // mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            name: '登录',
            path: '/login',
            component: require('../views/auth/WxLogin')
        },
        {
            name: '首页',
            path: '/',
            component: require('../views/Home')
        },
        ...generateRoutesFromMenu(menuModule.state.items),
        {
            path: '*',
            redirect: '/'
        }
    ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu(menu = [], routes = []) {
    for (let i = 0, l = menu.length; i < l; i++) {
        let item = menu[i]
        if (item.path) {
            routes.push(item)
        }
        if (!item.component) {
            generateRoutesFromMenu(item.children, routes)
        }
    }
    return routes
}



// WEBPACK FOOTER //
// ./src/router/index.js